import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * /conference/join/:inviteToken — resolves the token, then forwards the user
 * into the ConferenceRoom. Logged-out users are bounced to /login and returned.
 */
export default function ConferenceJoin() {
  const { inviteToken } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!user) {
      nav(`/login?next=${encodeURIComponent(`/conference/join/${inviteToken}`)}`, { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.get(`/meetings/by-token/${inviteToken}`);
        if (!data?.id) throw new Error("Invalid link");
        nav(`/conference/${data.id}?invite=${encodeURIComponent(inviteToken)}`, { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || "Invalid or expired invite link");
      }
    })();
    // eslint-disable-next-line
  }, [inviteToken, user?.user_id]);

  return (
    <div data-testid="conference-join-page" className="pt-32 text-center text-white/70 px-4">
      {err ? (
        <div className="max-w-md mx-auto tv-glass rounded-2xl p-10 border border-red-500/30">
          <div className="text-red-300 font-display font-black text-2xl">{err}</div>
          <button onClick={() => nav("/conference")} className="mt-5 bg-tv-accent text-black font-bold px-4 py-2 rounded-full text-sm">See my meetings</button>
        </div>
      ) : (
        <div>Joining meeting…</div>
      )}
    </div>
  );
}
